(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');
          if(recommendations && recommendations.innerHTML.trim().length){
            this.innerHTML = recommendations.innerHTML;
          }
          if(html.querySelector('.grid__item')){
            this.classList.add('product-recommendations--loaded');
          }
          document.querySelectorAll('.product-carousel').forEach(function(Element,index){
            let productid = Element.dataset.id;
            let outer_carousel = Element.closest('.related-products');
            let slider = new Splide(Element, {
              drag: 'free',
              pagination: false,
              perPage: 5,
              gap: 8,
              breakpoints: {
                991: {
                  perPage: 4,
                },
                767: {
                  perPage: 3,
                },
                575: {
                  perPage: 2,
                  autoWidth: true,
                  gap: 12,
                }
              }
            }).mount();
            if(typeof quickAddButton == 'function'){
              quickAddButton();
            }
            function onSwymLoadCallback(swat){
              if(swat){
                document.addEventListener("swym:collections-loaded", function(){
                  swat.initializeActionButtons("#collection-grid");
                })
                if(document.querySelector('.wishlist-success-msg')){
                  let event = 'sw:addedtowishlist';
                  let listener = function(e){
                    document.querySelector('.wishlist-success-msg').classList.add('active-wishlist');
                    setTimeout(function(){
                      document.querySelector('.wishlist-success-msg').classList.remove('active-wishlist');
                    },3000);
                  };
                  swat.evtLayer.addEventListener(event, listener);
                }
              }
            }
            if(!window.SwymCallbacks){
              window.SwymCallbacks = [];
            }
            window.SwymCallbacks.push(onSwymLoadCallback);
            if(document.querySelectorAll('.related-tab li')){
              document.querySelectorAll('.related-tab li').forEach((tab) =>{
                let currentVal = tab.getAttribute('data-title');
                if(Element.closest('.carousel-rowouter').getAttribute('data-title') == currentVal){
                  tab.addEventListener('click',function(e){
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    let tabsWithIsOpen = document.querySelectorAll(".related-tab li.active-tab");
                    tabsWithIsOpen.forEach((tabWithIsOpen) => {
                      tabWithIsOpen.classList.remove("active-tab");
                    });
                    tab.classList.add("active-tab");
                    let currentCarousel = Element.closest('.carousel-rowouter').getAttribute('data-title');
                    if(currentVal == currentCarousel){
                      let carouselsWithIsOpen = document.querySelectorAll(".carousel-rowouter.active-carousel");
                      carouselsWithIsOpen.forEach((carouselWithIsOpen) => {
                        carouselWithIsOpen.classList.remove("active-carousel");
                      });
                      Element.closest('.carousel-rowouter').classList.add("active-carousel");
                    }
                    slider.refresh();
                  });
                }
              });
            }
          });
        })
        .catch(e => {console.error(e);});
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
